import { UpdateCrecaTradesAdditionsApi } from "@/features/accounts/creca/services/update-trades-additions-api";
import { UpdateCrecaTradesAdditionsRequestModel } from "@/features/accounts/creca/services/update-trades-additions-model";

/// クレカAPI明細メモ・無効明細更新処理
export class UpdateCrecaTradesAdditionsService {
  private updateCrecaTradesAdditionsApi = new UpdateCrecaTradesAdditionsApi();

  /**
   * クレカAPI明細メモ・無効明細更新API実行
   */
  public async updateCrecaTradesAdditions(param: UpdateCrecaTradesAdditionsRequestModel) {
    return await this.updateCrecaTradesAdditionsApi.updateCrecaTradesAdditions(param);
  }
}
